import { AppFunctionComponent } from "../../../types"
import React, { MouseEvent, useState } from "react"
import PlusIcon from "../../../images/icon-plus.inline.svg"
import MinusIcon from "../../../images/icon-minus.inline.svg"
import { AccordionItem as AccordionItemProps } from "./mobile-accordion.interface"
import {
  ArrowWrapper,
  Bar,
  SubItems,
  Item,
  Path,
  Category,
  Input,
} from "./mobile-accordion.styled"

const MobileAccordion: AppFunctionComponent<AccordionItemProps> = ({
  path,
  displayName,
  extraDisplayName,
  children,
  level,
  isCategory,
  isInput,
  onClick,
  className,
}) => {
  const [active, setActive] = useState(false)

  const onClickActive = (event: MouseEvent<HTMLElement>): void => {
    setActive(!active)
    event.preventDefault()
  }

  return (
    <Item className={className} onClick={onClick}>
      <Bar level={level} $isCategory={isCategory} $active={active}>
        {isCategory ? (
          <Category $active={active} to={path}>
            {displayName}
          </Category>
        ) : isInput ? (
          <Input level={level} $active={active} $isCategory={isCategory}>
            {displayName}
            {active && extraDisplayName}
          </Input>
        ) : (
          <Path
            to={path}
            level={level}
            $active={active}
            $isCategory={isCategory}
          >
            {displayName}
            {active && extraDisplayName}
          </Path>
        )}
        {children && (
          <ArrowWrapper $active={active} onClick={onClickActive}>
            {active ? (
              <MinusIcon aria-label="hide" />
            ) : (
              <PlusIcon aria-label="expand" />
            )}
          </ArrowWrapper>
        )}
      </Bar>
      <SubItems $active={active}>{children}</SubItems>
    </Item>
  )
}

export default MobileAccordion
